module.exports = __webpack_public_path__ + "log-in/img/DocuPetTag.d647c724.png";